export const cssVideoCallHandler = {
  methods: {
    eventParticipants() {
      if (window.innerWidth > 850) {
        this.isActiveMenu = true
      } else {
        this.isActiveMenu = false
      }

      window.addEventListener('resize', this.resizeScreen)
    },

    resizeScreen() {
      if (window.innerWidth > 850 && this.isActiveMenu) {
        document.getElementById('participants').style.position = 'absolute'
        document.getElementById('main').style.width = 'calc(100% - 300px)'
        document.querySelector('.btn-block-video').style.width = 'calc(100% - 300px)'
        document.getElementById('participants').style.marginTop = '0'
      } else {
        document.getElementById('participants').style.position = 'absolute'
        document.getElementById('main').style.width = '100%'
        document.querySelector('.btn-block-video').style.width = '100%'
      }
    },

    closeParticipants() {
      this.isActiveMenu = false
      document.getElementById('participants').style.right = '-300px'
      document.getElementById('participants').style.marginTop = '0'
      document.getElementById('main').style.width = '100%'
      document.querySelector('.btn-block-video').style.width = '100%'
      setTimeout(() => {
        document.querySelector('.open-participants-header').style.display = 'block'
      }, 300)
    },

    openParticipants() {
      this.isActiveMenu = true
      document.getElementById('participants').style.right = '0'
      document.getElementById('participants').style.display = 'block'
      if (window.innerWidth > 850) {
        document.getElementById('participants').style.position = 'absolute'
        document.getElementById('main').style.width = 'calc(100% - 300px)'
        document.querySelector('.btn-block-video').style.width = 'calc(100% - 300px)'
      } else {
        document.getElementById('participants').style.position = 'absolute'
      }

      document.querySelector('.open-participants-header').style.display = 'none'
    },

    viewportMobile() {
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
  }
}
